import { ApiError } from '@gorila-shared-ui/components';
import { ApiEndpoint } from '../types/api';
import { InstallationLog, InstallationLogRequest, LogsTypes } from '../types/logs';
import { WsType } from '../types/webService';
import { MinimalWebServiceLog, WebServiceLog } from '../types/webServiceLogs';
import { getRequest, postRequest } from './api';
import { URLS } from './urls/urls';

export const getWebServiceLogs = async (
  clientId?: string,
  subClientId?: string,
  page?: number,
  q?: string,
  wsType?: WsType
): Promise<{ webServiceLogs?: MinimalWebServiceLog[]; error?: ApiError; total?: number }> => {
  const params = {
    clientId,
    subClientId,
    page,
    q,
    wsType,
  };
  const response = await getRequest(URLS.logs.webServiceList, {
    queryParams: params,
  });
  return {
    webServiceLogs: response?.data?.items,
    total: response?.data?.total,
    error: response?.error,
  };
};

export const getWebServiceLog = async (
  webServiceLogId: string
): Promise<{ webService?: WebServiceLog; error?: ApiError }> => {
  const response = await getRequest(URLS.logs.webServiceDetail(webServiceLogId));
  return {
    webService: response?.data,
    error: response?.error,
  };
};

// emissions
export const getLogsTypesList = async (): Promise<{
  logsTypes?: LogsTypes;
  error?: ApiError;
}> => {
  const response = await getRequest(URLS.logs.emissionsTypes, {}, ApiEndpoint.emissions);
  return {
    logsTypes: response?.data,
    error: response?.error,
  };
};

export const getInstallationLogsList = async (
  installationId: string
): Promise<{
  logs?: InstallationLog[];
  error?: ApiError;
}> => {
  const response = await getRequest(URLS.installations.logsList(installationId), {}, ApiEndpoint.emissions);
  return {
    logs: response?.data,
    error: response?.error,
  };
};

export const createLog = async (
  installationId: string,
  installationLogRequest: InstallationLogRequest
): Promise<{ error?: ApiError }> => {
  const response = await postRequest(
    URLS.installations.newLog(installationId),
    {
      body: installationLogRequest,
    },
    ApiEndpoint.emissions
  );
  return {
    error: response?.error,
  };
};
